import { Autocomplete, Input } from '@fullscreendigital/carrefour-dex-fe'

export const columns = [
  {
    title: 'Name',
    field: 'name',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Code',
    field: 'code',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Legal Entity',
    field: 'legalEntityName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Type',
    field: 'subtypeTypeName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Subtype',
    field: 'subtypeName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Regions',
    field: 'regionList.region.name',
    align: 'left',
    type: 'string',
    render: (row: any) =>
      row.regionList
        ? row.regionList.map((region: any) => `${region.name} - ${region.category}`).join(', ')
        : ''
  },
  {
    title: 'Status',
    field: 'locationStatusName',
    align: 'left',
    type: 'string'
  }
]

export const getFilters = (
  locationStatusesOptions: AutocompleteOption[],
  locationTypesOptions: AutocompleteOption[],
  locationSubtypesOptions: AutocompleteOption[],
  locationRegionsOption: AutocompleteOption[],
  locationSystemsOptions: AutocompleteOption[]
) => [
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    filter: <Input type="text" name="name" label="Name" variant="outlined" value="" />
  },
  {
    name: 'subtype.type.id',
    value: '',
    filter: <Autocomplete variant="outlined" label="Type" options={locationTypesOptions || []} />,
    type: 'autocomplete',
    label: 'Type'
  },
  {
    name: 'subtype.id',
    value: '',
    filter: (
      <Autocomplete variant="outlined" label="Subtype" options={locationSubtypesOptions || []} />
    ),
    type: 'autocomplete',
    label: 'Subtype'
  },
  {
    name: 'locationStatus.id',
    value: '',
    filter: (
      <Autocomplete variant="outlined" label="Status" options={locationStatusesOptions || []} />
    ),
    type: 'autocomplete',
    label: 'Status'
  },
  {
    name: 'externalIdList.system.name',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="System options"
        options={locationSystemsOptions || []}
        helperText="Please fill both System and External ID filters."
      />
    ),
    type: 'autocomplete',
    label: 'System options'
  },
  {
    name: 'externalIdList.value',
    label: 'External ID',
    type: 'text',
    filter: (
      <Input
        type="text"
        name="externalIdList.value"
        label="External ID"
        variant="outlined"
        value=""
        helperText="Please fill both System and External ID filters."
      />
    )
  }
]
